import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type BobbypinIconProps = CreateIconComponentProps;
export const BobbypinIcon: React.FC<BobbypinIconProps> = ({
  title = 'Bobbypin',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15.51 3.895 5.12 18.526 19.752 8.138c.632-.632 1.471-2.32-.226-4.017-1.697-1.697-3.385-.857-4.016-.226Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m16.899 6.749.354-.354"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="2"
      d="M6.294 4.854c.833.666 2.7 1.9 3.5 1.5 1-.5 2-3 3.5-3s2 1 3.5 3M18.794 9.354c.333.333.9 1.2.5 2-.5 1-3.5 4-4 5s-1 3 0 4 3 1 4 0"
    />
  </CreateIconComponent>
);
